import { UserApplicationItem } from '@app/application/components/item/UserApplicationItem';

export const SurrogateApplicationPage = () => {
  return <UserApplicationItem />;
};
